import { createFileRoute } from '@tanstack/react-router';
import { SyncChannelsList } from '@/features/mattermost-image-validation/components/SyncChannelsList';
import { usePermissions } from '@/common/hooks/usePermissions';
import { Permission } from '@/common/enums/permissions.enum';
import { Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/mattermost-sync-channels')({
  component: MattermostSyncChannelsPage,
});

function MattermostSyncChannelsPage() {
  const { hasPermission } = usePermissions();
  const hasAccess = hasPermission(Permission.MATTERMOST_IMAGE_VALIDATION);

  if (!hasAccess) {
    return <Navigate to="/" />;
  }

  return (
    <div className="container mx-auto py-6 px-4">
      <SyncChannelsList />
    </div>
  );
}
